import { combineReducers } from 'redux';

import redpacket from './redpacket';
import celebration2018 from './celebration2018';

export default combineReducers({ redpacket, celebration2018 });
